import { render, staticRenderFns } from "./ContentDisplay.vue?vue&type=template&id=63be776e&scoped=true"
import script from "./ContentDisplay.vue?vue&type=script&lang=js"
export * from "./ContentDisplay.vue?vue&type=script&lang=js"
import style0 from "./ContentDisplay.vue?vue&type=style&index=0&id=63be776e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63be776e",
  null
  
)

export default component.exports